<template>
  <span>
    <b-button type="button" variant="success" @click="toggle"><i class="fas fa-plus"></i> New message</b-button>
    <b-modal @show="resetModal" @hidden="resetModal" ref="modal-container" v-model="modalShow" size="lg" static lazy hide-footer>
      <template #modal-title="">
        <i class="fas fa-plus"/>&nbsp;New admin chat message
      </template>
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group :label="label" :label-for="`${id}-input`"
                      v-for="({id, label, validate = {}, required, type, disabled = false, options = null, placeholder = null}) in inputs"
                      :key="id">
          <b-form-input v-if="type === 'string'"
                        :id="`${id}-input`"
                        v-model="formValues[id]" v-validate="validate"
                        :placeholder="placeholder"
                        :state="validateState(id)" :aria-describedby="`${id}-live-feedback`" :data-vv-name="id"
                        :data-vv-as="label" autocomplete="off"
                        :disabled="disabled"
          />
          <b-form-input v-if="type === 'number'"
                        type="number"
                        :id="`${id}-input`"
                        v-model="formValues[id]" v-validate="validate"
                        :state="validateState(id)" :aria-describedby="`${id}-live-feedback`" :data-vv-name="id"
                        :data-vv-as="label" autocomplete="off"
                        :disabled="disabled"
          />
          <b-form-select
              v-if="type === 'select'"
              :id="`${id}-input`"
              v-model="formValues[id]" v-validate="validate"
              :options="options"
              :state="validateState(id)" :aria-describedby="`${id}-live-feedback`" :data-vv-name="id"
              :data-vv-as="label" autocomplete="off"
              :disabled="disabled"
          />
          <DatePicker
              v-if="type === 'datetime'"
              :id="`${id}-input`"
              input-class="form-control"
              type="datetime"
              v-model="formValues[id]"
              valueType="format"
              :placeholder="label"
              :disabled="disabled"
          />
          <b-form-input v-if="type === 'datetime'"
                        hidden
                        :id="`${id}-input`"
                        v-model="formValues[id]" v-validate="validate"
                        :state="validateState(id)" :aria-describedby="`${id}-live-feedback`" :data-vv-name="id"
                        :data-vv-as="label" autocomplete="off"
                        :disabled="disabled"
          />
          <b-form-invalid-feedback :id="`${id}-live-feedback`">{{ veeErrors.first(id) }}</b-form-invalid-feedback>
        </b-form-group>
      </form>

      <b-button class="mt-2 float-right" variant="primary" @click="handleSubmit">Add</b-button>
    </b-modal>
  </span>
</template>

<script>
import Vue from "vue";
import {getRouteIcon, ROUTE_WAZDAN_FREESPINS} from "../../utils/routerIcons";
import DatePicker from 'vue2-datepicker';

const colorsMap = {
  "green" : '#00ff00'
}

export default {
  components: {
    DatePicker
  },
  data() {
    return {
      modalShow: false,
      formValues: this.getInitialValues(),
      inputs: [
        {id: 'apiKey', label: 'Api Key', validate: {required: true}, type: 'string', disabled: true },
        {id: 'message', label: 'Message', validate: {required: true, min: 2, max: 1000}, type: 'string' },
        {id: 'color', label: 'Color', validate: {required: true}, type: 'select', options: [
            {value: 'red', text: 'red'},
            {value: 'yellow', text: 'yellow'},
            {value: 'green', text: 'green'},
            {value: 'blue', text: 'blue'},
            {value: 'white', text: 'white'},
          ]
        },
        {id: 'username', label: 'Username', validate: {required: true}, type: 'string' },
        {id: 'tableIds', label: 'Table IDs', validate: {required: true}, type: 'string', placeholder: 'Numbers, separated by comma' },
        {id: 'type', label: 'Type', validate: {required: true}, type: 'select', options: [
            {value: 1, text: 'Croupier chat'},
            {value: 2, text: 'Croupier and player chats'},
          ] },
      ],
    }
  },
  props: {
    defaultValues: Object
  },
  methods: {
    getInitialValues() {
      return {
        apiKey: process.env.VUE_APP_CHAT_API_KEY,
        message: null,
        color: 'red',
        username: null,
        tableIds: null,
        type: 1,
      };
    },
    validateState(ref) {
      if (
          this.veeFields[ref] &&
          (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    resetModal() {
      this.setDefaults();
    },
    hideModal() {
      this.$refs['modal-container'].hide();
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
    handleSubmit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        let data = {
          ...this.formValues,
          color: colorsMap[this.formValues.color] ?? this.formValues.color,
          tableIds: this.formValues.tableIds.split(',').map(tableId => Number.parseInt(tableId.trim())).filter(value => value),
        };
        this
            .$http({
              url: '/api/v1/admin-chat',
              method: 'POST',
              data: data,
              headers: {'Content-Type': 'application/json'},
            })
            .then(() => {
              this.hideModal();
              this.$toastr.i('Success');
              this.$emit('sentMessage', data)
            })
            .catch((err) => {
              this.$toastr.e(JSON.stringify(err.response.data.message));

              throw err;
            });
      });
    },
    setDefaults() {
      let initialValues = this.getInitialValues();

      for (let field in initialValues) {
        Vue.set(this.formValues, field, initialValues[field]);
      }

      if (this.defaultValues) {
        for (let field in this.defaultValues) {
          Vue.set(this.formValues, field, this.defaultValues[field]);
        }
      }
    },
  },
  computed: {
    routeIcon: () => getRouteIcon(ROUTE_WAZDAN_FREESPINS),
  },
  mounted() {
    this.setDefaults();
  },
}
</script>
